import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const TabsBox = styled(Box, {})({
  display: 'flex',

  justifyContent: 'space-evenly',

  borderBottom: 1,
  background: theme.palette.white,

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.newSecondary,
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    height: '100%',

    backgroundColor: theme.palette.backgroundgrey,
  },

  '& .MuiButtonBase-root.MuiTab-root': {
    zIndex: 2,

    padding: '0 8px',
    minWidth: 20,

    border: 'none',

    color: theme.palette.placeholdergrey,
    fontSize: 14,

    '&.Mui-selected': {
      color: theme.palette.black,
    },
  },
});
